import {ReactNode, createContext, useState, useEffect} from "react"

export type CompanyContextValue = {
    clientId: number
    setClientId: (empresaId: number) => void,
    clientSolicitationId: number,
    setClientSolicitationId: (empresaSolicituId: number) => void,
    loaded: boolean,
    setLoaded: (arg: boolean) => void
}

export type CompanyProviderProps = {
    children: ReactNode
}

export const CompanyContext = createContext<CompanyContextValue>({
    clientId: 0,
    setClientId: () => 0,
    clientSolicitationId: 0,
    setClientSolicitationId: () => 0,
    loaded: false,
    setLoaded: () => false
})

export const CompanyProvider = ({ children }: CompanyProviderProps) => {
    const [clientId, setClientId] = useState<number>(0)
    const [clientSolicitationId, setClientSolicitationId] = useState<number>(0)
    const [loaded, setLoaded] = useState<boolean>(false)
    
    useEffect(() => {
        const id = localStorage.getItem('solicitationId');
        if(id) setClientSolicitationId(parseInt(id))
        
        const companyId = localStorage.getItem('companyId');
        if(companyId) setClientId(parseInt(companyId))
    }, [])

    return (
        <CompanyContext.Provider value={{ clientId: clientId, setClientId: setClientId, clientSolicitationId: clientSolicitationId, setClientSolicitationId: setClientSolicitationId, loaded, setLoaded }}>
            {children}
        </CompanyContext.Provider>
    )
}